var elem = document.querySelector('.hero__carousel');
if(elem) {
	var flkty = new Flickity( elem, {
	// options
		cellAlign: 'left',
		contain: true,
		prevNextButtons: false,
		autoPlay: 4000,
		wrapAround: true
	});
}

var elem = document.querySelector('.testimonials__carousel');
if(elem) {
	var flkty = new Flickity( elem, {
	// options
		cellAlign: 'left',
		contain: true, 
		autoPlay: 4000,
		prevNextButtons: false,
		rightToLeft: true,
		wrapAround: true
	});
}

var elem = document.querySelector('.customer__carousel');
if(elem) {
	var flkty = new Flickity( elem, {
	  // options
		cellAlign: 'left',
		contain: true,
		prevNextButtons: false,
		pageDots: false,
		autoPlay: 2000,
		wrapAround: true
	});
}

$(document).ready(function(){
    // All links that start with #
    $("[data-review-jump-link]").click(function(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: ($( $(this).attr('href') ).offset().top)
        }, 500);

        return false;
	});
	



	// Toggle blog filters
	$('[data-blog-filter]').click(function() {
		if($(this).hasClass('c-dd-sim--active')) {
			$('body').removeAttr('data-dd-sim-open', true);
			$(this).removeClass('c-dd-sim--active');
		}else {
			$('body').attr('data-dd-sim-open', true);
			$('.c-dd-sim--active').removeClass('c-dd-sim--active');
			$(this).addClass('c-dd-sim--active');
		}
	});

	    // Close when something other than the dd content is clicked 
		$(document).on('click', '[data-dd-sim-open]', function() {
			$('.c-dd-sim--active').removeClass('c-dd-sim--active');
			$('body').removeAttr('data-dd-sim-open', true);
		});

		//If the  content or the trigger are clicked - stop propagation so the dd isn't closed
		$('body').on('click', '[data-blog-filter-trigger]', function(e) {
			e.stopPropagation();          
		});
});


// Slider
$(document).ready(function(){
    //Single-food slider
    $('[data-food-slider]').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: false,
        asNavFor: '[data-food-nav-slider]',
        nextArrow: $('[data-food-slider-nav="next"]'),
        prevArrow: $('[data-food-slider-nav="prev"]'),
    });

    $('[data-food-nav-slider]').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '[data-food-slider]',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        nextArrow: $('[data-food-slider-nav="next"]'),
        prevArrow: $('[data-food-slider-nav="prev"]'),
    });
});


// WEBPACK FOOTER //
// ./main.js